/** @format */

export default {
    SINGLE: 'Single',
    MULTIPLE: 'Multiple',
};
